import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

const PopoverWithImage = (props) => {
  const styles = useStyles();
  const { title, description, imgTitle, imgSrc, } = props;

  return (
    <>
      <h4 className={styles.title}>{title}</h4>
      <span className={styles.description}>{description}</span>

      {imgTitle}
      <img src={imgSrc} alt="hint" />
    </>
  );
};

const useStyles = createUseStyles({
  title: {
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '25px',
    color: '#6F6C77',
  },
  description: {
    fontWeight: 500,
  },
  topSpace: {
    marginTop: 10,
  },
});

PopoverWithImage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imgTitle: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
}

export default PopoverWithImage;
